import { useState } from "react";

export default function useForm({ initialValues, onChange }) {
    const [values, setValues] = useState(initialValues);

    function handleSubmit(callback) {
        return async function (event) {
            event.preventDefault();
            await callback(values);
        };
    }

    function handleChange(event = { name: "", value: null }) {
        if (Array.isArray(event)) {
            setValues((old) => {
                const data = { ...old };
                event.map((field) => {
                    data[field.name] = field.value;
                });
                return data;
            });
        } else {
            setValues((old) => {
                if (onChange) onChange({ ...old, [event.name]: event.value });
                return { ...old, [event.name]: event.value };
            });
        }
    }

    function register(
        options = {
            name,
            id,
            placeholder: "",
            type: "text",
            required: false,
            onChange: null,
        },
        additionalOptions = {
            onChange: null,
        }
    ) {
        if (Array.isArray(options)) {
            const fields = [];

            options.map((option) => {
                const { name, id, placeholder, type, required, ...props } =
                    option;
                fields.push({
                    name: name,
                    id: id || name,
                    placeholder: placeholder,
                    type: type,
                    required: required,
                    value: name in values ? values[name] : "",
                    ...props,
                });
            });

            return {
                fields,
                onChange: function (event = []) {
                    if (additionalOptions.onChange)
                        additionalOptions.onChange({
                            values: event.reduce((prev, curr) => {
                                return { ...prev, [curr.name]: curr.value };
                            }, values),
                            event,
                        });
                    handleChange(event);
                },
            };
        }

        const { name, id, placeholder, type, required, onChange, ...props } =
            options;
        return {
            name: name,
            id: id || name,
            placeholder: placeholder,
            type: type,
            required: required,
            value: name in values ? values[name] : "",
            onChange: ["text", "number", "password"].includes(type)
                ? function (event) {
                      if (onChange) {
                          onChange({
                              values: {
                                  ...values,
                                  [event.target.name]: event.target.value,
                              },
                              event,
                          });
                      }
                      handleChange({
                          name: event.target.name,
                          value: event.target.value,
                      });
                  }
                : function (event) {
                      if (onChange)
                          onChange({
                              values: { ...values, [event.name]: event.value },
                              event,
                          });
                      handleChange(event);
                  },
            ...props,
        };
    }

    function reset(values = {}) {
        setValues(values);
    }

    return {
        values,
        handleChange,
        register,
        handleSubmit,
        reset,
    };
}
